import { redirect, useRouteLoaderData, type LoaderFunctionArgs } from 'react-router';
import type { MeResponse } from '@hefesto/contracts';
import { ApiFailure, get, post } from './api';
import { singlePortalTarget } from './portal';

/**
 * Sesión en el navegador: la fuente es SIEMPRE `/api/v1/me` (cookie HttpOnly). No hay tokens en
 * JS ni en localStorage/sessionStorage. Las rutas protegidas usan `requireSession` como loader.
 */
export async function requireSession({ request }: LoaderFunctionArgs): Promise<MeResponse> {
  let me: MeResponse;
  try {
    me = await get<MeResponse>('/v1/me');
  } catch (error) {
    if (error instanceof ApiFailure && error.status === 401) {
      const url = new URL(request.url);
      const next = url.pathname + url.search;
      throw redirect(next === '/' ? '/login' : `/login?next=${encodeURIComponent(next)}`);
    }
    throw error;
  }
  // (03A) Con UNA sola empresa (y sin ser del equipo de Mot's), el inicio es su portal.
  if (new URL(request.url).pathname === '/') {
    const target = singlePortalTarget(me);
    if (target) throw redirect(target);
  }
  return me;
}

export const SESSION_ROUTE_ID = 'session';

export function useMe(): MeResponse {
  return useRouteLoaderData(SESSION_ROUTE_ID) as MeResponse;
}

/** `?next=` solo acepta rutas internas (evita redirecciones abiertas a otros sitios). */
export function safeNext(value: string | null, fallback = '/'): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\'))
    return fallback;
  return value;
}

export const signIn = (email: string, password: string) =>
  post('/auth/sign-in/email', { email, password, rememberMe: true });

export const signOut = () => post('/auth/sign-out');
export const revokeAllSessions = () => post('/auth/revoke-sessions');
